import { Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import {ApiRequest, UniversalImportTemplateEnum, IApiresponse} from "src/app/_models";
import { ExcelExportService } from "src/app/_services/common/excel-export.service";
import { UniversalImporterService } from "src/app/_services/universal-importer/universal-importer.service";
import { StorageData } from "src/app/_models/universal-importer/universal-importer";
import { AppGridComponent } from "src/app/shared/grid/grid-component/grid.component";
import { ColDef } from "ag-grid-community";
import { GridConfig } from "src/app/_models/common/grid/grid-config";
import { GradeCsvRecord, IRequestGradeListAll, IResponseGrade, IResponseGradeList, RequestGradeListAll } from "src/app/_models/grade/grade";
import { GradeService } from "src/app/_services";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";

@Component({
    selector: "grade-import-export-panel",
    templateUrl: "./grade-import-export-panel.component.html",
    standalone: false
})

export class GradeImportExportPanelComponent implements OnInit {
    @ViewChild(AppGridComponent) gridComponent: AppGridComponent;

    @Output() closePanelEvent = new EventEmitter<boolean>();
    howDoIVideoLinks = HowDoIVideoLinks;
    gridColumnDefs: ColDef[];
    gridConfigItems: GridConfig;
    gridData: any[] = [];
    sampleTemplate = <GradeCsvRecord[]>[];
    claims: Claims;
    panelHeading: string;
    categoryList: any[] = [];
    importSampleData: any[]=[];
    showImportInstuctionPanel: boolean= false;

    gradeList = <IResponseGrade[]>[];

    constructor(
        private claimsService: ClaimsService,
        private router: Router,
        private translate: TranslateService,
        private excelExportService: ExcelExportService,
        private gradeService: GradeService,
        private universalImporterService: UniversalImporterService
    ) {
        this.claimsService.currentClaims.subscribe((claims) => {
           this.claims = claims;
        });
    }

    ngOnInit() {
      this.fnInitialiseGrid();
      this.getGradeForOrg();
    }

    fnClosePanel() {
        this.closePanelEvent.emit(true);
    }


    fnInitialiseGrid() {

        this.fnCreateColumnDefs();
        this.fnGetGridConfigItems();
        setTimeout(() => {
            this.gridComponent.initializeGrid();
        }, 100);

    }

    fnCreateColumnDefs() {
        this.gridColumnDefs = [
            {
                headerName: this.translate.instant('grade_name_label'),
                field: 'gradeName',
                resizable: true,
                sortable: true,
                suppressHeaderMenuButton: true,
                minWidth: 100,
              },
              {
                headerName: this.translate.instant('grade_description_label'),
                field: 'gradeDescription',
                resizable: true,
                sortable: true,
                suppressHeaderMenuButton: true,
                minWidth: 100,
              },
        ]


    }

    fnGetGridConfigItems() {
        this.gridConfigItems = new GridConfig(
            true,
            true,
            'gradeId',
            'gradeId',
            0,
            false,
            [],
            true,
            true,
            true,
            null,
            'asc',
            40,
            this.translate.instant('no_data_availabe'),
            null,
            null,
            false,
            false,
            '', 
            '',
            false
        );
    }

    

    fnGridFilterChanged() {
        this.fnGetGridConfigItems();
        this.fnCreateColumnDefs();

        setTimeout(() => {
            this.gridComponent.refreshGridData();
        }, 100);
    }

    
   

    fnExportSampleFile() {
        let csvRecord: GradeCsvRecord = new GradeCsvRecord();
        csvRecord.gradeName = "";
        csvRecord.gradeDescription = "";
        this.sampleTemplate.push(csvRecord);
        this.gradeService.exportData(this.sampleTemplate, "Grade", false);
    }

    
    fnExportGrades() {
        const categoryExport = [];
        let headerRow = [
            this.translate.instant('grade_name_label'),
            this.translate.instant('grade_description_label')
        ];
        categoryExport.push(headerRow);
        if(this.gridData && this.gridData.length > 0){
            this.gridData.forEach(data => {
                let row = [];
                row.push(data.gradeName ? data.gradeName:"");
                row.push(data.gradeDescription ? data.gradeDescription : "");
                categoryExport.push(row); 
            });
        }
        this.excelExportService.exportToCsv("Grade.csv", categoryExport);
      }

    fnImportEmployees(){
        let storageData = new StorageData();
        storageData.importTemplate = UniversalImportTemplateEnum.ImportGrade;
        this.universalImporterService.fnSaveDataToLocalStorage(storageData);
        localStorage.setItem("isCameFromGradeImport" + this.claims.OrgId, "1");
        this.router.navigate(["/universalimport/uploadfile"]);
      }

    fnShowImportInstuctionPanel(){
          this.showImportInstuctionPanel = true;
      }

    fnCloseImportInstuctionPanel(){
        this.showImportInstuctionPanel = false;
    }



    getGradeForOrg() {
        let gradeRequest = new ApiRequest<IRequestGradeListAll>(
          "SoloGetAllGradeByOrgId",
          1.0,
          "111"
        );
        let gradeRequestInfo = new RequestGradeListAll(this.claims.OrgId);
        gradeRequest.requestInfo = gradeRequestInfo;
        this.gradeService
          .GetAllGradeByOrgId(gradeRequest)
          .subscribe((response: IApiresponse<IResponseGradeList>) => {
            if (response.responseInfo != null) {
              this.gradeList = response.responseInfo.gradeList;
              this.gridData = this.gradeList;
              this.fnGridFilterChanged();
            }
          });
      }
      gradeExport = <GradeCsvRecord[]>[];
      exportGrade(): void {
        for (let i = 0; i < this.gradeList.length; i++) {
          let csvRecord: GradeCsvRecord = new GradeCsvRecord();
          csvRecord.gradeName = this.gradeList[i].gradeName;
          csvRecord.gradeDescription = this.gradeList[i].gradeDescription;
          this.gradeExport.push(csvRecord);
        }
        this.gradeService.exportData(
          this.gradeExport,
          "GradeExport" + new Date().getTime(),
          false
        );
      }

}


